module.exports = __webpack_public_path__ + "img/H2O.53175453.png";